import './scss/style.scss';
import 'bootstrap/dist/js/bootstrap.bundle.js';
import functions from './js/functions';

import flatpickr from "flatpickr";
flatpickr.localize(flatpickr.l10ns[functions.getLang()]);
flatpickr.l10ns.default.firstDayOfWeek = 1;
import 'flatpickr/dist/l10n/hr.js';

import 'lightgallery/src/js/lightgallery.js';
import 'lightgallery/modules/lg-fullscreen.js';
import 'lightgallery/modules/lg-thumbnail.js';

import lozad from 'lozad';

import './js/globals';
import './js/slider';
import './js/components/loadGmap';
import './js/list';
import './js/details';
import './js/booking';
//import './js/blog';
import './js/contact';

window.observer = lozad('.lozad', {
    rootMargin: '200px 0px',
    loaded: el => {
        $(el).triggerHandler('lozadLoaded');
    }
});
window.observer.observe();

window.nobserver = lozad('.load-recaptcha', {
    rootMargin: '200px 0px',
    loaded: el => {
        $.getScript("https://www.google.com/recaptcha/enterprise.js?render=" + functions.getRecaptchaKey());
    }
});
window.nobserver.observe();